import { create } from "zustand";

/**
 * Marketing Consent Store State
 */
type MarketingConsentStoreType = {
  /** Whether the marketing consent modal has been shown in this session */
  hasMarketingConsentShown: boolean;

  /** Set whether the marketing consent modal has been shown */
  setHasMarketingConsentShown: (value: boolean) => void;

  /** Reset the marketing consent shown state */
  resetMarketingConsent: () => void;
};

/**
 * Zustand store for managing marketing consent UI state
 * Replaces: hasMarketingConsentShownStateAtom from recLib/atoms/marketingConsent.ts
 *
 * Note: The form data (checkbox/email values) are now managed by react-hook-form
 * in MarketingConsentPopup, replacing marketingConsentAtom.
 */
export const useMarketingConsentStore = create<MarketingConsentStoreType>(
  (set) => ({
    hasMarketingConsentShown: false,

    setHasMarketingConsentShown: (value) =>
      set({ hasMarketingConsentShown: value }),

    resetMarketingConsent: () => set({ hasMarketingConsentShown: false }),
  }),
);
